<template>
    <v-layout align-start>
        <v-flex>
             <v-data-table
                :headers="headers"
                :items="enlaces"
                :search="search"
                class="elevation-1">
                <template v-slot:top>
                    <v-toolbar flat color="white">
                    <v-toolbar-title>Enlaces</v-toolbar-title>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>
                    <v-spacer></v-spacer>
                    <v-text-field class="text-xs-center" 
                        v-model="search" append-icon="search" 
                        label="Busqueda" single-line hide-details></v-text-field>
                    <v-spacer></v-spacer>
                    <!-- ********** -->
                    <v-dialog v-model="dialog" fullscreen 
                        hide-overlay transition="dialog-bottom-transition">
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" 
                                dark v-on="on" 
                              
                                outlined>Crear enlace</v-btn>
                        </template>
                        <v-card>
                            <v-toolbar dark color="primary">
                                 <v-btn icon dark @click="close">
                                   <v-icon>close</v-icon>
                               </v-btn>
                                <v-toolbar-title><span class="headline">Enlaces</span></v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-toolbar-items>
                                    <!-- <v-btn dark text @click="newItem">Limpiar Controles</v-btn> -->
                                </v-toolbar-items>
                                <!-- <v-btn class="ma-2" @click="Limpiar()" outlined color="indigo">Limpiar Controles</v-btn> -->
                                <v-spacer></v-spacer>
                                <v-toolbar-items>
                                   
                                    <v-btn 
                                        dark text
                                        @click="saveItem"
                                        >
                                        Grabar
                                    </v-btn>
                                </v-toolbar-items>
                            </v-toolbar>                        
                            <v-list three-line subheader>
                                <!-- <v-subheader><strong> Seleccione Tipo de grupo</strong></v-subheader> -->
                                <v-container fluid>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="6">
                                            <v-text-field
                                                label="Descipcion"
                                                v-model="editedItem.descripcion"
                                                outlined>
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" lg="4">
                                            <v-text-field
                                                label="URL"
                                                v-model="editedItem.url"
                                                outlined>
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" lg="4">
                                        <v-menu
                                            ref="FechaIni"
                                            v-model="FechaIni"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            max-width="290px"
                                            min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    v-model="editedItem.fechaInicio"
                                                    label="Fecha Inicio"
                                                    prepend-icon="event"
                                                    readonly
                                                    v-on="on">
                                                </v-text-field>
                                            </template>
                                            <v-date-picker v-model="editedItem.fechaInicio" no-title @input="FechaIni = false"></v-date-picker>
                                        </v-menu>
                                    </v-col>
                        
                                    <v-col cols="12" lg="4">
                                    <v-menu
                                            v-model="FechaFin"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            max-width="290px"
                                            min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    v-model="editedItem.fechaFin"
                                                    label="Fecha Fin"
                                                    prepend-icon="event"
                                                    readonly
                                                    v-on="on">
                                                </v-text-field>
                                            </template>
                                            <v-date-picker v-model="editedItem.fechaFin" no-title @input="FechaFin = false"></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                     <v-switch v-model="editedItem.vigencia" class="ma-2" label="Vigencia"></v-switch>
                                      <v-switch v-model="editedItem.sustituir" class="ma-2" label="Sustituir"></v-switch>
                                    </v-row>
                                </v-container>
                            </v-list>
                        </v-card>
                        <v-divider></v-divider>
                    </v-dialog>
                    <!-- ********** -->
                    </v-toolbar>
                </template>
                

                <!-- GRID DE LA PANTALLA PRINCIPAL -->
                <template v-slot:body="{ items }">
                    <tbody>
                        <tr v-for="item in items" :key="item.name">
                            <td>
                                <div>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                        <v-btn icon v-on="on">
                                            <v-icon small class="mr-2" @click="editItem(item)">
                                             edit
                                            </v-icon>
                                        </v-btn>
                                        </template>
                                        <span>Editar</span>
                                    </v-tooltip>
                                </div>
                            </td>
                            <td>{{ item.idEnlace }}</td>
                            <td>{{ item.descripcion }}</td>
                            <td>{{ item.url }}</td>
                            <td>{{ item.fechaInicio | formatDate }}</td>
                            <td>{{ item.fechaFin | formatDate }}</td>
                             <td>
                                <v-icon class="mr-2">
                                    {{ item.sustituir ? 'done_outline' : 'highlight_off' }}
                                </v-icon>
                            </td>
                            <td>
                                <div v-if="item.vigencia" @click="estatus(item)">
                                    <v-btn class="green--text" text >Activo</v-btn>
                                </div>
                                <div v-else @click="estatus(item)">
                                    <v-btn class="red--text" text >Inactivo</v-btn>
                                </div>
                                <!-- <v-icon class="mr-2">
                                    {{ item.vigencia ? 'done_outline' : 'highlight_off' }}
                                </v-icon> -->
                            </td>
                           
                        </tr>
                    </tbody>
                </template> 
                <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">Resetear</v-btn>
                </template>
            </v-data-table>
        </v-flex>
    </v-layout>
</template>  

<script>
import moment from 'moment'
export default {
    components: {
    },
    data() {
        return {
            enlaces:[],
            catUsuarios: [],
            editedItem: {   
                idEnlace: 0,
                descripcion: '',
                icono: 'icono',
                vigencia: true,
                url:'',
                fechaInicio: new Date().toISOString().substr(0, 10),
                fechaFin: new Date().toISOString().substr(0, 10),
                sustituir: false
                },

            dialogFecha: false,
            FechaIni: false,
            FechaFin: false,
            consultaDto: {
                Skip: 0,
                Take: 100,
                descending: true,
                sortBy: '',
                search: ''
            },
            dialog: false,
            headers: [
                { text: 'Opciones', value: 'opciones', sortable: false },
                { text: 'IdEnlace', value: 'idEnlace' },
                { text: 'Descripcion', value: 'descripcion' },
                { text: 'URL', value: 'url' },
                { text: 'Fecha Inicio', value: 'fechaIncio' },            
                { text: 'Fecha Fin', value: 'fechaFin' },     
                { text: 'Sustituir', value: 'sustituiir' },          
                { text: 'Vigencia', value: 'vigencia' }            
            ],
            search: '',
        }
    },
    computed: { },
    watch: { },
    created () { },
    mounted () {
        this.Default()
    },
    filters: {
        formatDate(date){
            return moment(date).format('L')
        }
    },
    methods: {
        Default () {
            debugger
            let me = this
            me.$store.dispatch('setIsBusy', true)
            me.$axios.get('api/Enlace/Get')
                .then(r => {
                    if (r.data.exito) {
                        me.enlaces = r.data.datos
                        // me.newItem()
                    }
                })
                .catch(e => { console.log(e) })
             me.$store.dispatch('setIsBusy', false)
           
        },
       close() {
            this.dialog = false;
           this.editedItem = { 
                idEnlace: 0,
                descripcion: '',
                icono: 'icono',
                vigencia: true,
                url:'',
                fechaInicio: new Date().toISOString().substr(0, 10),
                fechaFin: new Date().toISOString().substr(0, 10),
                sustituir: false
           }
        },
         estatus (item) {
            let me = this
            me.$store.dispatch('setIsBusy', true)
            me.$axios.get('api/Enlace/Estatus?Id=' + item.idEnlace)
                .then(s => {
                    if(s.data.exito) {
                        me.$root.Mensaje('Estatus actualizado')
                    } else {
                        me.$root.Mensaje(s.data.mensaje)
                    }
                    me.Default();
                    me.$store.dispatch('setIsBusy', false)
                    me.dialog = false
                })
                .catch(e => {                     
                    this.$root.Mensaje(e.data.mensaje)
                })
         },
        editItem (item) {
            this.editedItem = item
            this.dialog = true
        },
        saveItem () {
            let me = this
            me.$store.dispatch('setIsBusy', true)
            var js = {
               "IdEnlace" : me.editedItem.idEnlace,
               "Descripcion" : me.editedItem.descripcion,
               "URL" : me.editedItem.url,
               "Icono" : me.editedItem.icono,
               "FechaInicio" : me.editedItem.fechaInicio,
               "FechaFin" : me.editedItem.fechaFin,
               "Vigencia" : me.editedItem.vigencia,
               "Sustituir" : me.editedItem.sustituir
            }
            console.log(js)
            me.$axios.post('api/Enlace/Save', js)
                .then(s => {
                    if(s.data.exito) {
                        me.$root.Mensaje('Enlace creado')
                        this.Default();
                    } else {
                        me.$root.Mensaje(s.data.mensaje)
                    }
                    me.$store.dispatch('setIsBusy', false)
                    me.dialog = false
                })
                .catch(e => { this.$root.Mensaje(e.data.mensaje) })
        }
    }
}
</script>
